export const vendors = ['energybox', 'monnit', 'venstar'];
export var GatewayVendorLabel;
(function (GatewayVendorLabel) {
    GatewayVendorLabel["energybox"] = "Energybox";
    GatewayVendorLabel["monnit"] = "G-Hub";
    GatewayVendorLabel["UNASSIGNED"] = "";
})(GatewayVendorLabel || (GatewayVendorLabel = {}));
export var GatewayNetworkInterfaceHumanReadable;
(function (GatewayNetworkInterfaceHumanReadable) {
    GatewayNetworkInterfaceHumanReadable["LTE_OVER_LAN"] = "LTE over LAN";
    GatewayNetworkInterfaceHumanReadable["ETHERNET_ONLY"] = "LAN only";
    GatewayNetworkInterfaceHumanReadable["LTE_ONLY"] = "LTE only";
})(GatewayNetworkInterfaceHumanReadable || (GatewayNetworkInterfaceHumanReadable = {}));
export var StaticIp;
(function (StaticIp) {
    StaticIp["true"] = "Enabled";
    StaticIp["false"] = "Disabled";
    StaticIp["undefined"] = "Unknown";
})(StaticIp || (StaticIp = {}));
export var GatewaySirenState;
(function (GatewaySirenState) {
    GatewaySirenState["DISARMED"] = "DISARMED";
    GatewaySirenState["ARMED"] = "ARMED";
    GatewaySirenState["ALARM_ON"] = "ALARM_ON";
    GatewaySirenState["MUTED"] = "MUTED";
})(GatewaySirenState || (GatewaySirenState = {}));
export var GatewayStates;
(function (GatewayStates) {
    GatewayStates["NORMAL_MODE"] = "NORMAL_MODE";
    GatewayStates["PAIRING_MODE"] = "PAIRING_MODE";
    GatewayStates["BUFFER_MODE"] = "BUFFER_MODE";
    GatewayStates["ALERT_ENABLED"] = "ALERT_ENABLED";
    GatewayStates["RF_DISABLED"] = "RF_DISABLED";
    GatewayStates["CONTROL_OVERRIDE"] = "CONTROL_OVERRIDE";
    GatewayStates["SIM_INSERTED"] = "SIM_INSERTED";
    GatewayStates["OTA_IN_PROGRESS"] = "OTA_IN_PROGRESS";
})(GatewayStates || (GatewayStates = {}));
export var GatewayPowerSupplies;
(function (GatewayPowerSupplies) {
    GatewayPowerSupplies["POWER_ADAPTER"] = "POWER_ADAPTER";
    GatewayPowerSupplies["USB"] = "USB";
    GatewayPowerSupplies["BATTERY"] = "BATTERY";
    GatewayPowerSupplies["POE"] = "POE";
})(GatewayPowerSupplies || (GatewayPowerSupplies = {}));
// Taking advantages of ordered enum type
// Power supply mask is a number starting form 1
// First value in the enum is set to UNKNOWN ( It should never hit this case )
export var PowerSupplyMaskHumanReadable;
(function (PowerSupplyMaskHumanReadable) {
    PowerSupplyMaskHumanReadable[PowerSupplyMaskHumanReadable["UNKNOWN"] = 0] = "UNKNOWN";
    PowerSupplyMaskHumanReadable[PowerSupplyMaskHumanReadable["ACDC"] = 1] = "ACDC";
    PowerSupplyMaskHumanReadable[PowerSupplyMaskHumanReadable["PoE"] = 2] = "PoE";
    PowerSupplyMaskHumanReadable[PowerSupplyMaskHumanReadable["USB"] = 3] = "USB";
})(PowerSupplyMaskHumanReadable || (PowerSupplyMaskHumanReadable = {}));
export var SystemType;
(function (SystemType) {
    SystemType[SystemType["COOL_ONLY"] = 0] = "COOL_ONLY";
    SystemType[SystemType["HEAT_ONLY"] = 1] = "HEAT_ONLY";
    SystemType[SystemType["COOL_OR_HEAT"] = 2] = "COOL_OR_HEAT";
    SystemType[SystemType["HP_COOL_ONLY"] = 3] = "HP_COOL_ONLY";
    SystemType[SystemType["HP_HEAT_ONLY"] = 4] = "HP_HEAT_ONLY";
    SystemType[SystemType["TWO_STAGE_HEAT"] = 5] = "TWO_STAGE_HEAT";
    SystemType[SystemType["SINGLE_STAGE_COOL_HEAT"] = 6] = "SINGLE_STAGE_COOL_HEAT";
    SystemType[SystemType["TWO_STAGE_COOL_HEAT"] = 7] = "TWO_STAGE_COOL_HEAT";
})(SystemType || (SystemType = {}));
export var HvacType;
(function (HvacType) {
    HvacType["HEAT_PUMP"] = "Heatpump";
    HvacType["ELECTRIC"] = "Electric";
    HvacType["GAS"] = "Gas";
    HvacType["COOL_ONLY"] = "Conventional - Cool Only";
    HvacType["HEAT_ONLY"] = "Conventional - Heat Only";
    HvacType["COOL_OR_HEAT"] = "Conventional - Cool & Heat";
    HvacType["HP_COOL_ONLY"] = "Heatpump - Cool Only";
    HvacType["HP_HEAT_ONLY"] = "Heatpump - Single Stage Heat Only";
    HvacType["TWO_STAGE_HEAT"] = "Heatpump - Two Stage Heat Only";
    HvacType["SINGLE_STAGE_COOL_HEAT"] = "Heatpump - Single Stage Cool & Heat";
    HvacType["TWO_STAGE_COOL_HEAT"] = "Heatpump - Two Stage Cool & Heat";
})(HvacType || (HvacType = {}));
export var HeatingSytem;
(function (HeatingSytem) {
    HeatingSytem["ELECTRIC"] = "Electric";
    HeatingSytem["GAS"] = "Gas";
})(HeatingSytem || (HeatingSytem = {}));
export var ReversingValve;
(function (ReversingValve) {
    ReversingValve["REVERSING_VALVE_B"] = "Reversing Valve B (Terminal energizes in heating)";
    ReversingValve["REVERSING_VALVE_O"] = "Reversing Valve O (Terminal energizes in cooling)";
})(ReversingValve || (ReversingValve = {}));
export const logSeverity = {
    EMERG: 0,
    ALERT: 1,
    CRITICAL: 2,
    ERROR: 3,
    WARNING: 4,
    NOTICE: 5,
    INFO: 6,
    DEBUG: 7,
};
export const networkInterface = {
    LTE_OVER_LAN: 0,
    LAN_OVER_LTE: 3,
};
export var SirenTriggerEvents;
(function (SirenTriggerEvents) {
    SirenTriggerEvents["DOOR_OPEN"] = "DOOR_OPEN";
})(SirenTriggerEvents || (SirenTriggerEvents = {}));
export var GatewayNetworkType;
(function (GatewayNetworkType) {
    GatewayNetworkType["UNKNOWN"] = "UNKNOWN";
    GatewayNetworkType["LAN"] = "LAN";
    GatewayNetworkType["LTE"] = "LTE";
    GatewayNetworkType["ETHERNET"] = "ETHERNET";
})(GatewayNetworkType || (GatewayNetworkType = {}));
export var GATEWAY_TYPES;
(function (GATEWAY_TYPES) {
    GATEWAY_TYPES["OPERATIONAL"] = "OPERATIONAL";
    GATEWAY_TYPES["CONTROL"] = "CONTROL";
    GATEWAY_TYPES["ENERGY"] = "ENERGY";
})(GATEWAY_TYPES || (GATEWAY_TYPES = {}));
